module.exports = {"TXTWCL_Deposit":{"id":"TXTWCL_Deposit","defaultMessage":"Deposit","track":"Deposit"}}